<template>

    <iframe  :id="id" :src="url" frameborder="0" width="100%" height="800px" scrolling="auto" :allowfullscreen="allowfullscreenFlag"></iframe>

</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN,USER_LANGUAGE } from "@/store/mutation-types"
  import store from '@/store/'
  import { getAction } from '@/api/manage'
  import PageLayout from '../page/PageLayout'
  import RouteView from './RouteView'
  import {mapState} from "vuex";

  export default {
    name: "IframePageContent",
    inject:['closeCurrent'],
    data () {
      return {
        url: "",
        id:"",
        fullPath:'',
        permissionId:'',
        allowfullscreenFlag: true,
      }
    },
    created () {
      this.goUrl()
    },
    mounted(){
      window.addEventListener('message', this.handleMessage);
    },
    updated () {
      this.goUrl()
    },
    watch: {
      $route(to, from) {
        this.goUrl();
      }
    },
    computed: {
      ...mapState({
        // 主路由
        mainRouters: state => state.permission.addRouters,
        // 后台菜单
        permissionMenuList: state => state.user.permissionList
      })
    },
    methods: {
      getPermissionId(permissionMenuList){
        let item = this.fullPath;
        for(let i=0; i<permissionMenuList.length; i++){
          if(permissionMenuList[i].path === item || permissionMenuList[i].meta.url === item){
            this.permissionId = permissionMenuList[i].id;
            break;
          } else {
            if(permissionMenuList[i].children && permissionMenuList[i].children.length > 0){
              this.getPermissionId(permissionMenuList[i].children);
            }
          }
        }
      },
      goUrl () {
        let that = this;
        let url = this.$route.meta.url
        let path = this.$route.path;
        let id = path.substring(1);
        that.id = id

        this.fullPath = window.sessionStorage.getItem('BiCurrentFullPath');
        let permissionMenuList = this.permissionMenuList;
        this.getPermissionId(permissionMenuList);
        if(url){
          that.url = that.calculateMiddlePath(url);
          // that.closeCurrent();
          // window.open(that.url);
          that.openNewTab(that);
          return;
        }
        let middlePath = path.substring(path.indexOf("}")+1);
        if(id.indexOf("${") == 0){
          let serverName = id.substring(2,id.indexOf("}"));
          let param = {
            id: serverName
          };
          getAction("/sys/permission/getBiPrefixUrl", param).then((res) => {
            if (res.success) {
              if (id !== null && id !== undefined) {
                let middlePath1 = that.calculateMiddlePath(middlePath);
                that.url = `${res.result}${middlePath1}`;
                that.openNewTab(that);
              }
            } else {
              that.$message.warning(res.message);
            }
          })
        } else {
          that.url = that.calculateMiddlePath(middlePath);
          that.openNewTab(that);
        }
      },
      openNewTab(that){
        /*update_begin author:wuxianquan date:20190908 for:判断打开方式，新窗口打开时this.$route.meta.internalOrExternal==true */
        if(that.$route.meta.internalOrExternal != undefined && that.$route.meta.internalOrExternal==true){
          that.closeCurrent();
          window.open(that.url);
        }
        /*update_end author:wuxianquan date:20190908 for:判断打开方式，新窗口打开时this.$route.meta.internalOrExternal==true */
      },

      calculateMiddlePath(middlePath){
        // let username = "PbiAdmin";
        let username = store.getters.userInfo.username;
        let token = Vue.ls.get(ACCESS_TOKEN);
        let langCode = window.sessionStorage.getItem(USER_LANGUAGE) || "zh_CN";
        let permissionId = this.permissionId;
        let appId=this.$store.getters.application.id;
        if(username && token){
          let $Username = "${username}";
          if(middlePath.indexOf($Username)){
            middlePath = middlePath.replace($Username,username)
          }
          let $Token = "${token}";
          if(middlePath.indexOf($Token)){
            middlePath = middlePath.replace($Token,token)
          }
          let $PermissionId = "${permissionId}";
          if(middlePath.indexOf($PermissionId) && permissionId != ''){
            middlePath = middlePath.replace($PermissionId,permissionId);
          } else if (!permissionId){
            middlePath = middlePath.replace($PermissionId, '');
          }
          let $LangCode = "${langCode}";
          if(middlePath.indexOf($LangCode)){
            middlePath = middlePath.replace($LangCode,langCode);
          }
          let $appId = "${appId}";
          if(middlePath.indexOf($appId)){
            middlePath = middlePath.replace($appId,appId);
          }
          return middlePath;
        }
        return middlePath;
      },
      handleMessage (event) {
        // 根据上面制定的结构来解析iframe内部发回来的数据
        const data = event.data;
        this.$router.push(data);
      },
    }
  }
</script>

<style>
</style>